import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container footer-inner">
        <span className="footer-text">andy siegel</span>
        <span className="footer-text">washington, dc</span>
      </div>
    </footer>
  );
};

export default Footer;
